const Data = [{
    icon: 'bi bi-building-fill',
    id: 'bms',
    title: 'Building Management System',
    description: 'Successfully unify all of your control, monitoring, and operational requirements. Our unique solutions are based on providing results for your buildings to reduce operational costs, increase efficiency & effectiveness and prepare your building for the future and internet of things.'
},
{
    icon: 'bi bi-sign-turn-slight-right-fill',
    id: 'ts',
    title: 'TURNSTILE SOLUTION',
    description: 'Alcon oﬀers safe, reliable, convenient and stylish Half & Full-Height Physical Access System which are available in many diﬀerent designs, colors and forms - suited for diﬀerent applications such as corporate buildings, industrial sites, research institutions, IT centers, banks, airports, sport stadiums and more'
},
{
    icon: 'bi bi-building-fill-check',
    id: 'vms',
    title: 'VISITOR MANAGEMENT SYSTEM',
    description: 'To avoid a lot of interruptions and receptionists being stuck at their desks, visitor management system was developed to illuminate challenges associated to office productivity, where it can be used to track visitors and people who enters the buildings or offices in a formal way.'
},
{
    icon: 'bi bi-p-circle-fill',
    id: 'pms',
    title: 'PARKING MANAGEMENT SYSTEM',
    description: 'Designed to manage diﬀerent requirements necessary for professional management of parking areas, Alcon’s Parking Management System not only optimizes your parking programs but also delivers convenient solutions for drivers. Facilitate reservation, navigation and payment literally with the use of your fingertips.'
},
{
    icon: 'bi bi-pci-card',
    id: 'bb',
    title: 'BOOM BARRIER',
    description: 'Conveniently easy yet controlled entry. That is what Alcon’s Barriers and Fences are for. All barriers and fences are developed and designed using high grade raw material in accordance with international quality standards.'
},
{
    icon: 'bi bi-sign-no-parking-fill',
    id: 'pgs',
    title: 'PARKING GUIDANCE SYSTEM',
    description: 'Alcon’s Parking Guidance System incorporates traffic monitoring, communication, processing, and variable message sign automation to convey services. A system designed to relief drivers find available parking spaces by directing them to under-occupied parking slot.'
},
{
    icon: 'bi bi-hdd-stack-fill',
    id: 'scs',
    title: 'STRUCTURED CABLING SYSTEM',
    description: 'Alcon indulges complete cabling systems and associated hardware that implement a comprehensive telecommunications infrastructure for a wide range of applications, including providing telephone services or transmitting data over computer networks.'
},
{
    icon: 'bi bi-mic-fill',
    id: 'voisd',
    title: 'VOICE OVER IP SYSTEM DESIGN',
    description: 'Voice over Internet Protocol (also called VoIP, IP Telephony, Internet Telephony, and Broadband Phone) is the routing of voice conversations over the internet or through any other IP-based network. In general, phone service via VoIP is a free or costs less than equivalent service from traditional sources but similar to alternative PSTN (Public Switched Telephone Network) service providers. VoIP to VoIP phone calls are typically free, whilst VoIP to PSTN calls generally costs much cheaper than PSTN to PSTN calls. We can provide you good quality and low price choices for your telecommunication cost cutting.'
},
{
    icon: 'bi bi-tablet-landscape-fill',
    id: 'is',
    title: 'INTERCOM SYSTEM',
    description: 'An intercom is a two-way electronic communication device containing circuitry for sending and receiving audio and/or video transmissions. Alcon Philippines offers systems such as wireless, wired, video intercom, door and gate opening and closing, and a large variety of systems. This system can be used in buildings or clusters of buildings that operate independently of the public telephone network.'
},
{
    icon: 'bi bi-modem-fill',
    id: 'cs',
    title: 'CATV SYSTEM',
    description: 'The distribution of signals, specifically via satellite and subsequent transmission over coaxial or fiber optic cables to nearby homes or service subscribing entities, is one of the systems Alcon provides.'
},
{
    icon: 'bi bi-megaphone-fill',
    id: 'pabms',
    title: 'PUBLIC ADDRESS AND BACKGROUND MUSIC SYSTEM',
    description: 'Voice Alarm is increasingly important in the safe management of buildings. A voice message informs occupants exactly what to do in an emergency and it is a long-established fact that people respond more quickly and are more likely to take the correct action during an evacuation if voice messages are used instead of tone sounders. Voice Alarm systems are not only used for public buildings with a high number of visitors, but are also used more and more for public address and entertainment systems.'
},
{
    icon: 'bi bi-exclamation-octagon-fill',
    id: 'ias',
    title: 'INTRUSION ALARM SYSTEM',
    description: 'Our systems use the latest technologies and range from intruders alarms, control panels and motion sensors to fully integrated intrusion and door control security installations. They also include environmental protection and life safety devices, and perimeter protection products including glass break, seismic and shock sensors'
},
{
    icon: 'bi bi-house-lock-fill',
    id: 'has',
    title: 'HOME AUTOMATION SYSTEM',
    description: 'Having the capability to automatically and/or remotely manage systems and devices within a home in order to improve its security, comfort, and consumption. Alcon Philippines features a smart home that allows you to manage many functions of the house in a simple way, including lighting, energy management, heating, video intercom, and security.'
},
{
    icon: 'bi bi-fingerprint',
    id: 'acs',
    title: 'Access Control & Biomentric System',
    description: 'Our product lines allow simple access control of visitors, employees and the general public throughout a site. With low maintenance costs, easy to expand Access control system, key less convenience, simplicity to set up and change configuration as required and extremely fast lock release..'
},
{
    icon: 'bi bi-fire',
    id: 'fdas',
    title: 'FIRE DETECTION AND ALARM SYSTEM',
    description: 'Achieve protection at any level with our state-of-the-art fire protection solutions. We have a complete line of detectors and other alarm components applicable to different businesses with different requirements. We believe that ownership of fire detection systems extends beyond the initial purchase of the products themselves. We therefore offer customers a wide range of services to ensure that their installations not only meet basic operational and safety requirements on day one, but will continue to do so throughout their lifetime'
},
{
    icon: 'bi bi-webcam-fill',
    id: 'sc',
    title: 'Surveillance Camera',
    description: 'We oﬀer a complete and wide variety of compatible DVR, NVR, Analog, Megapixel HD-SDI and Network Cameras to meet all application and budgets.'
},
{
    icon: 'bi bi-speaker-fill',
    id: 'pabms',
    title: 'Public Address and Background Music System',
    description: 'Fill the silence and create an atmosphere with our ﬂexible systems that support both simple and the most complex communication and background music needs.'
},
{
    icon: 'bi bi-wifi',
    id: 'wbs',
    title: 'Wireless Broadband Solution',
    description: 'Our wireles systems give businesses a more cost-eﬀective and application-competitive network, one which can simply be integrated to other networks and helps to easily expand the business.'
},
{
    icon: 'bi bi-exclamation-triangle-fill',
    id: 'eams',
    title: 'Earthquake Alert and Monitoring System',
    description: 'The seismic recording and instrumentation machine must be used to set off alarms at specified intensity levels triggering real-time alarm information and may also trigger automatic switch off for utilities such as gas lines, electric power lines and elevators as may be prudent in case of such high intensity earthquake.  The recorded data are also important parameters for buildings safety re-evaluation and resumption of occupancy including post-earthquake evaluation of buildings..'
}
];

export default Data;